import React from "react";
import { CheckedIcon } from "../icon";
import "./submited-form.scss";

export interface SubmitedProps {
    title?: string;
    description?: string;
}



const AppSubmitedForm = (props: SubmitedProps) => {

    return (
        <div className="submited-form">
            <CheckedIcon />
            <p className="title">{props.title}</p>
            <small>{props.description}</small>
        </div>
    )
}

export default AppSubmitedForm